export function serverType(type) {
  return [
    "None",
    "Forest Camp",
    "Lafayette",
    "Lakeview",
    "Lone Pine",
    "Bunker",
    "Black Earth",
    "Test",
    "Farm",
  ][type];
}

export const serverTypes = [0, 1, 3, 5, 6];
